import { Chip } from '@sunwebgroup/ui-components';
import type { MouseEventHandler } from 'react';

const SelectedValue = ({
  value,
  className,
  children,
  removeOption,
}: {
  value: string;
  className?: string;
  children: string;
  removeOption: (value: string) => void;
}) => {
  const handleRemoveClick: MouseEventHandler = (e) => {
    e.preventDefault();
    e.stopPropagation();
    removeOption(value);
  };

  return (
    <Chip value={value} className={className} removable onClick={handleRemoveClick}>
      {children}
    </Chip>
  );
};

export default SelectedValue;
